import { render, staticRenderFns } from "./item.vue?vue&type=template&id=b03f2e6a&scoped=true&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=b03f2e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03f2e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b03f2e6a')) {
      api.createRecord('b03f2e6a', component.options)
    } else {
      api.reload('b03f2e6a', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=b03f2e6a&scoped=true&", function () {
      api.rerender('b03f2e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/drawer/item.vue"
export default component.exports